import { collectVariableUsage } from 'node_modules/tsutils';
import { Subject } from 'rxjs';
import { Machine } from './../machine/machine';
import { DispatchItemService } from './../dispatchitem/dispatchitemservice';
import { FixCatService } from './../fixcat/fixcatservice';
import { TrackingService } from './../tracking/trackingservice';
import { Client } from '../client/client';
import { ClientService } from '../client/clientservice';
import { MachineService } from '../machine/machineService';
import { TicketService } from '../ticket/ticketService';
import { UserService } from './../_services/user.service';
import { Status } from '../status/status';
import { User } from '../user/user';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Authenticate } from '../authenticate/authenticate';
import { DispatchOrderCreate } from '../dispatch-order/dispatch-order';
import { DispatchOrderService } from '../dispatch-order/dispatch-order-service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ML } from '../comment/ML';
import { Sendgridservice } from '../_services/sendgridService';
import { TrackingCreate } from '../tracking/tracking';
import { FixCat } from '../fixcat/fixcat';
import { TicketCreate } from '../ticket/ticket';
import { LogEventService } from '../logevent/logeventservice';
import { DispatchItem } from '../dispatchitem/dispatchitem';
import { walkUpBindingElementsAndPatterns } from 'typescript';

@Component({
  selector: 'app-dispatch-order-create',
  templateUrl: './dispatch-order-create.component.html',
  styleUrls: ['./dispatch-order-create.component.css', '../app.component.less']
})
export class DispatchOrderCreateComponent implements OnInit {
  //#region variables
  _sn: string;
  _machines: Machine[];
  _selectedmachineid: number = 1;
  _statuses: Status[];
  _selectedstatusid: number = 1;
  _client: Client;
  _currentUser: User;
  _title: string;
  _details: string;
  _newstatus: Status;
  redirecturl: string;
  _errorcode: string;
  _current_counter: number;
  _userRole: string;
  searchquery: string;
  auth: Authenticate
  jwt: string;
  _mids: number[] = [];
  _ml: ML;
  _shipper: string;
  _trackingnumber: string;
  _fixcats: FixCat[];
  _fid: number[] = [];
  _tDetails: string[] = [];
  _tids: number[] = [];
  _orderitems: DispatchItem[] = [];
  ml: ML;
  _newticket: TicketCreate;
  _selectedfixes: FixCat[] = [];
  //#endregion
  constructor(private _userservice: UserService,
    private _clientservice: ClientService,
    private _machineservice: MachineService,
    private _ticketservice: TicketService,
    private _dispatchorderservice: DispatchOrderService,
    private datePipe: DatePipe,
    private router: Router,
    private sendgridservice: Sendgridservice,
    private trackingservice: TrackingService,
    private fixcatservice: FixCatService,
    private ticketservice: TicketService,
    private logevenetservice: LogEventService,
    private dispatchitemservice: DispatchItemService
  ) { }



  // PAGE LOAD FUNCTION
  ngOnInit(): void {
    this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
    this.jwt = this.auth.jwt;
    let role = this.auth.user.role.name;
    this._userservice.getCurrentUser().subscribe(response => {
      this._currentUser = response;
      this._client = response.client;
      this._userRole = role;
      this.fixcatservice.getCats().subscribe(res => { this._fixcats = res });

    });
  }

  // Search Function with using variable criteria
  async search(serialnumber) {


    // CHECK USER IF ADMINISTRATOR VERSYS EMPLOYEE OR CLIENT
    if (this._userRole == "Authenticated" || this._userRole == "Administrator") {
      this._machineservice.getMachineByCriteriaAdmin('serialnumber', serialnumber, environment.token).subscribe(async machines => {

        // Check if machine already dispatched 
        if (machines[0].dispatched) {
          window.alert("THE MACHINE IS ALREADY DISPATCHED! PLEASE SPEAK TO AN ADMINISTRATOR!");
          return;
        }



        try {
          // CHECK IF MACHINE IS ALREADY IN LIST
          if (!machines[0].serialnumber.includes(serialnumber)) { }
          else
          // ADD MACHINE TO LIST
          {
            if (this._machines == null) {
              this._machines = []
              this._machines.push(machines[0]);
              var tempItem: DispatchItem = new DispatchItem;
              tempItem.fixcats = [];
              this._orderitems.push(tempItem);
            }
            else {
              if (this.exists(machines[0])) { window.alert("MACHINE IS Already there") }
              else {
                this._machines.push(machines[0]);
                var tempItem: DispatchItem = new DispatchItem;
                tempItem.fixcats = [];
                this._orderitems.push(tempItem);
              }
            }
          }
        }
        catch (e) {
          console.log(e);
          window.alert("Device is not registered. Please contact Versys Administration.");
        }
      }
      );
    } else {
      // USER IS CLIENT CAN ONLY SEARCH CLIENT MACHINES
      this._machineservice.getMachineByCriteria('serialnumber', serialnumber, this._currentUser.client.id, environment.token).subscribe(machines => {
        try {
          // Check if machine already dispatched 
          if (machines[0].dispatched) {
            window.alert("THE MACHINE IS ALREADY DISPATCHED! PLEASE SPEAK TO AN ADMINISTRATOR!");
            return;
          }

          // CHECK IF MACHINE IS ALREADY IN LIST
          if (!machines[0].serialnumber.includes(serialnumber)) { }
          else {
            if (this._machines == null) {
              this._machines = []
              this._machines.push(machines[0]);
              var tempItem: DispatchItem = new DispatchItem;
              tempItem.fixcats = [];
              this._orderitems.push(tempItem);
            }
            else {
              if (this.exists(machines[0])) { window.alert("MACHINE IS Already there") }
              else {
                this._machines.push(machines[0]);
                var tempItem: DispatchItem = new DispatchItem;
                tempItem.fixcats = [];
                this._orderitems.push(tempItem);
              }
            }
          }
        } catch (e) // MACHINE IS NOT IN THE SYSTEM
        {
          console.log(e);
          window.alert("Device is not registered. Please contact Versys Administration.");
        }
      }
      );
    }
  }

  // Create Dispatch Order
  createDispatch(): void {

    if (this._details == null || this._shipper == null || this._trackingnumber == null || !this.fixCheck()) {
      window.alert("Please fill the details information for the delivery.")
    }
    else {
      this.getMids();
      var disp: DispatchOrderCreate;
      disp = new DispatchOrderCreate;
      disp.client = this._client.id;
      disp.user = this._currentUser.id;
      disp.machines = this._mids;
      var timestamp = new Date();
      this.datePipe.transform(timestamp, "yyyy-MM-dd");
      disp.date = timestamp;
      disp.details = this._details;
      disp.dispatchstate = 3;
      disp.fixcats = this._fid;
     
      this.updateMachineStates(this._machines);

      this._dispatchorderservice.createDispatchOrder(disp).subscribe(async resp => {
     
        //SEND EMAIL NOTIFICATION
        this._ml = new ML();
        this._ml.content = "New Dispatch Order Sent." + disp.details.replace(/<[^>]+>/g, '') + "<br><strong>Number of Machines = " + disp.machines.length;
        this._ml.subject = "Dispatch Order";
        this._ml.sender = this._currentUser.firstname + " " + this._currentUser.lastname;
        this._ml.senton = timestamp;
        this._ml.senderemail = this._currentUser.email;
        this._ml.receipientemail = "issam.khatib@k2ss.fr"

        this.sendgridservice.sendMail(this._ml).subscribe(any => { });

        // CREATE TRACKING RECORD
        var trk: TrackingCreate = new TrackingCreate;
        trk.date = timestamp;
        trk.trackingstate = 1;
        trk.dispatchorder = resp.id;
        trk.user = this._currentUser.id;
        trk.shipper = this._shipper;
        trk.trackingnumber = this._trackingnumber;
        this.trackingservice.createTracking(trk).subscribe(resp => { });
        // Create Tickets
        await this.createTickets(this._machines, resp.id);
        // LOG EVENT DISPATCH CREATE
        this.logevenetservice.logEventDo(this._currentUser.id, "Dispatch Create",
          {
            button: 'Send Dispatch',
            page: 'DispatchOrderCreate',
            devices: this._machines,
            result: 'Success'
          }, resp.id, null);

        //Redirect to Order detail view
        this.redirecturl = "/dispatchorders/" + resp.id;
        this.router.navigateByUrl(this.redirecturl);
      });
    }
  }

  // Get Machine IDs Array
  getMids() {
    var i = 0;
    while (i < this._machines.length) {
      this._mids.push(this._machines[i].id);
      i++;
    }
  }

  // Set Machine State to Down
  updateMachineStates(machines: Machine[]) {
    var i = 0;
    while (i < this._machines.length) {
      this._machineservice.changeState(machines[i].id, 2).subscribe(resp => { });
      this._machineservice.changeDispatch(machines[i].id, true).subscribe(resp => { });
      i++;
    }
  }

  // Create Machines Tickets
  async createTickets1(machines: Machine[], doId: number) {
    var i = 0;
    while (i < this._machines.length) {

      //CREATE DISPATCH ORDER ITEMS
      this._orderitems[i].dispatchorder = doId;
      this._orderitems[i].machine = this._machines[i];
      this._orderitems[i].details = this._tDetails[i];

      // CREAT THE DISPATCH ITEM ELEMENT
      this.dispatchitemservice.createDispatchItem(this._orderitems[i]).subscribe(async resp => {
        // CREATE TICKETS FOR EACH ORDER ITEM
        var templength = resp.fixcats.length;
        this._newticket = new TicketCreate;
        this._newticket.title = resp.machine.shortname + " Repair";
        this._newticket.status = 1;
        this._newticket.machines = resp.machine.id;
        this._newticket.details = "<figure class=\"table\"><table><tbody><tr><td><strong>Repair Item&nbsp;</strong></td><td><strong>Desctiption</strong></td></tr>"
        var j = 0
        this._newticket.user = this._currentUser.id;
        this._newticket.client = resp.dispatchorder.client;
        this._newticket.errorcode = resp.machine.shortname + " Repair";
        var timestamp = new Date();
        this.datePipe.transform(timestamp, "yyy-MM-dd");
        this._newticket.dateofticket = timestamp;
        this._newticket.dateresolved = timestamp;
        this._newticket.fixcat = this._fid[i];
        this._newticket.dispatchorder = doId;
        this._newticket.dispatchitem = resp.id;
        this._newticket.resolution = " ";


        // CREATE TABLE OF FIX CATEGORIES   
        while (j < templength) {
          this._newticket.details = this._newticket.details + "<tr><td>" + (j + 1) + "</td><td>" + resp.fixcats[j].cat + "</td></tr>"
          // CHECK IF LAST RECORD AND CREATE TICKET
          if (j == templength - 1) {
            this._newticket.details = this._newticket.details + "</tbody></table></figure>"
            await this.ticketservice.createTicket(this._newticket).subscribe();
          }
          j++;
        }
      });
      i++;
    }
  }
  async createTickets(machines: Machine[], doId: number) {
    var i = 0;
    while (i < this._machines.length) {
      //CREATE DISPATCH ORDER ITEMS
      this._orderitems[i].dispatchorder = doId;
      this._orderitems[i].machine = this._machines[i];
      this._orderitems[i].details = this._tDetails[i];
      // Create dispatch item (Ensure each request completes before continuing)
      await new Promise((resolve, reject) => {
        this.dispatchitemservice.createDispatchItem(this._orderitems[i]).subscribe(resp => {
          var templength = resp.fixcats.length;
          this._newticket = new TicketCreate();
          this._newticket.title = resp.machine.shortname + " Repair";
          this._newticket.status = 1;
          this._newticket.machines = resp.machine.id;
          this._newticket.details = `<figure class="table"><table><tbody><tr><td><strong>Repair Item</strong></td><td><strong>Description</strong></td></tr>`;
          this._newticket.user = this._currentUser.id;
          this._newticket.client = resp.dispatchorder.client;
          this._newticket.errorcode = resp.machine.shortname + " Repair";
          var timestamp = new Date();
          this._newticket.dateofticket = timestamp;
          this._newticket.dateresolved = timestamp;
          this._newticket.fixcat = this._fid[i];
          this._newticket.dispatchorder = doId;
          this._newticket.dispatchitem = resp.id;
          this._newticket.resolution = " ";
          var j = 0;
          while (j < templength) {
            this._newticket.details += `<tr><td>${j + 1}</td><td>${resp.fixcats[j].cat}</td></tr>`;
            // If it's the last fix category, finalize details and create the ticket
            if (j === templength - 1) {
              this._newticket.details += "</tbody></table></figure>";
              // Ensure each ticket creation is completed before moving to the next
              new Promise((resolveTicket, rejectTicket) => {
                this.ticketservice.createTicket(this._newticket).subscribe({
                  next: () => {
                    console.log(`✅ Ticket created for machine: ${resp.machine.shortname}`);
                    resolveTicket(true);
                  },
                  error: (error) => {
                    console.error(`❌ Error creating ticket:`, error);
                    rejectTicket(error);
                  }
                });
              }).then(resolve).catch(reject);
            }
            j++;
          }
        }, error => reject(error));
      });
      i++;
    }
  }

  // Remove Machine from Array
  remove(index) {
    this._machines.splice(index, 1);
    this._tDetails.splice(index, 1);
    this._orderitems.splice(index, 1);
  }

  // CHECK IF MACHINE EXISTS IN ARRAY
  exists(machine: Machine): boolean {
    try {
      var i = 0;
      var result = false;
      while (i < this._machines.length) {
        if (this._machines[i].serialnumber == machine.serialnumber) {
          result = true;
        }
        else {
          result = false;
        }

        i++;
      }

      return result;
    }
    catch (e) {
      return false;
    }
  }
fixCheck() : boolean
{
for (let item of this._orderitems) {
    if (item.fixcats.length== 0) {
     return false;
    }
  }
  return true;
}

}
